import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import logo from "../../assets/logo_fsky.png"; // Ensure the correct path
import logonew from "../../interior_assets/newlogosky1.png";
import "./navbar.css";
import { Link, useNavigate } from "react-router-dom"; // Fixed Import
import Contactpopup from "../contact_popup/contactpopup";
import { FaHome } from "react-icons/fa";

function Navbar() {
    const navigate = useNavigate();
    const [isPopupOpen, setPopupOpen] = useState(false);

    const openPopup = () => {
        setPopupOpen(true);
    };

    // Function to close the popup
    const closePopup = () => {
        setPopupOpen(false);
    };
    return (
        <>
        {/* dropdown-toggle */}
            <nav className="navbar navbar-expand-lg navbar-light  fixed-top shadow-sm nav-color-bck">
                <div className="container-fluid">
                    {/* Logo Section */}
                    <Link className="navbar-brand" to="/interiorpage" style={{  textTransform: "uppercase", color: "white", fontWeight: 500,  fontSize: "15px"}}>
                        <img src={logo} alt="Logo"  width="58" height="51" 
                        style={{ marginRight: "4px",    }} />
                       First Sky Infra
                    </Link>

                    <Link className="nav-link " to="/" id="dropdown-icon"
                                    style={{ fontWeight: 500, margin: "0 -9px" }}>
                                  <FaHome className="get-button-icon" style={{ color: "#FDC30B" , fontSize:"25px"}} />
                                </Link>
                  
          

                    <button
                        className="navbar-toggler toggler-change"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarNav"
                        aria-controls="navbarNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                      
                    >
                        <span className="navbar-toggler-icon"></span>
                    </button>

                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav mx-auto">
                            {/* Portfolio Dropdown */}
                            <li className="nav-item dropdown">
                                <Link className="nav-link " to="/portfoliopage"onClick={() => window.scrollTo(0, 0)}
                                    style={{ textTransform: "uppercase", color: "white", fontWeight: 500, margin: "0 10px" }}>
                                    PORTFOLIO
                                </Link>
                               
                            </li>


                            {/* Architecture Dropdown */}
                            <li className="nav-item dropdown">
                                <Link className="nav-link " to="/architecture"onClick={() => window.scrollTo(0, 0)}
                                    style={{ textTransform: "uppercase",  fontWeight: 500, margin: "0 10px" }}>
                                    Architecture
                                </Link>
                             
                            </li>

                          
                            <li className="nav-item dropdown">
                                <Link className="nav-link " to="/projectmanagement"
                                onClick={() => window.scrollTo(0, 0)}
                                    style={{ textTransform: "uppercase",  fontWeight: 500, margin: "0 10px" }}>
                                    Project Management
                                </Link>

                            </li>
                            <li className="nav-item dropdown dropdown-home" >
                                <Link className="nav-link " to="/"
                                    style={{ fontWeight: 500, margin: "0 10px" }}>
                                  <FaHome className="get-button-icon" style={{ color: "#FDC30B" , fontSize:"25px"}} />
                                </Link>

                            </li>
                          
                        </ul>


                        {/* Get Enquiry Button */}
                        <button className="btn get-button" onClick={openPopup}>
                            Get Enquiry
                        </button>
                    </div>
                </div>
            </nav>
            {/* Conditionally render the Contactpopup */}
            {isPopupOpen && <Contactpopup onClose={closePopup} />}
        </>
    );
}

export default Navbar;
